// extracted by mini-css-extract-plugin
module.exports = {"main":"expanded-row_main_2m6ro","serviceTD":"expanded-row_serviceTD_25E28","defaultTD":"expanded-row_defaultTD_38WXi"};